import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router-dom";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useDispatch, useSelector } from "react-redux";
import { listContractorMasterAsync } from "../../../../redux/features/contractor-master/contractorMasterListSlice";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";
import { changeStatus } from "../../../../Api/dispatch/contractor-dispatch";
import * as XLSX from "xlsx";
import moment from "moment/moment";
import { useBoolean } from "../../../../Hooks/useBoolean";
import DownloadReportButton from "../../../../components/common/DownloadReportButton";
import { contractorMasterReportAsync } from "../../../../redux/features/reportSlice";

const ContractorMasterList = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();

   const { dataList, loading, error } = useSelector(
      (state) => state.contractorMasterListSlice,
   );

   const [records, setRecords] = useState();
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const reportPopup = useBoolean();

   useEffect(() => {
      if (dataList) setRecords(dataList);
   }, [dataList]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listContractorMasterAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   // Handle active inactive
   const handleActiveInactive = (contractor) => {
      setIsActiveLoading({ id: contractor?.id, status: true });
      changeStatus({
         id: contractor?.id,
         status: contractor?.is_active === "1" ? "0" : "1",
      })
         .then((res) => {
            setIsActiveLoading({ id: contractor?.id, status: false });
            dispatch(listContractorMasterAsync({}));
            toast.success(
               `contractor ${contractor?.is_active === "1" ? "deactivated" : "activated"}`,
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: contractor?.id, status: false });
            //toast.error(
            //    `Failed to ${
            //       contractor?.is_active === "1" ? "deactivate" : "activate"
            //    } contractor`,
            // );
         });
   };

   //  Download fleet Report
   const handleDownloadReport = (data) => {
      dispatch(backdropLoadingAction(true));

      dispatch(
         contractorMasterReportAsync({
            data: data,
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
            done: (report) => {
               const headers = [
                  "S. No.",
                  "Contractor Name",
                  "Location",
                  "Address",
                  "GST Details",
                  "Contractor Account No.",
                  "Contractor IFSC Code",
                  "Agreement Details (1,2,3… Multiple addition required)",
                  "",
                  "Contact Person Details",
               ];

               const subheaders = [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "Start Date",
                  "End Date",
                  "Name",
                  "Phone No.",
                  "Email",
               ];

               const contractorMasterDataArr = [];

               let contractorMasterMaxSubArrLength = 0;
               let contractorMasterId = null;

               report?.forEach?.((item, index) => {
                  contractorMasterMaxSubArrLength = Math.max(
                     item?.contact_personal_details?.length ?? 0,
                     item?.contractor_agreement?.length ?? 0,
                  );

                  for (let i = 0; i < contractorMasterMaxSubArrLength; i++) {
                     const arr = [];
                     arr.push(
                        contractorMasterId === item?.id ? "-" : index + 1, // S. No.
                        item?.name ?? "-", // Contractor Name
                        item?.location_master?.name ?? "-", // Location
                        item?.address ?? "-", // Address
                        item?.gst_no ?? "-", // GST Details
                        item?.account_no ?? "-", // Contractor Account No.
                        item?.ifsc_code ?? "-", // Contractor IFSC Code
                        item?.contractor_agreement?.[i]?.start_date ?? "-", // Agreement Start Date
                        item?.contractor_agreement?.[i]?.end_date ?? "-", // Agreement End Date
                        item?.contact_personal_details?.[i]?.name ?? "-", // Contact Person Name
                        item?.contact_personal_details?.[i]?.mobile ?? "-", // Contact Person Phone No
                        item?.contact_personal_details?.[i]?.email ?? "-", // Contact Person Emain
                     );
                     contractorMasterId = item?.id;
                     contractorMasterDataArr.push(arr);
                  }
               });

               // Combine headers and rows
               const sheetData = [headers, subheaders, ...contractorMasterDataArr];

               const ws = XLSX.utils.aoa_to_sheet(sheetData);

               // Merging cells to create a header with sub-columns
               ws["!merges"] = [
                  { s: { r: 1, c: 7 }, e: { r: 1, c: 8 } }, // Merging cells for "Agreement Details"
                  { s: { r: 1, c: 9 }, e: { r: 1, c: 11 } }, // Merging cells for "Agreement Details"
               ];

               const wb = XLSX.utils.book_new();
               XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
               XLSX.writeFile(wb, "CONTRACTOR_MASTER_REPORT.xlsx");
               dispatch(backdropLoadingAction(false));
               reportPopup.onFalse();
            },
         }),
      );
   };

   const columns = [
      {
         name: "Contractor Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Account Holder Name",
         selector: (row) => {
            return row.account_holder_name;
         },
      },
      {
         name: "Location",
         selector: (row) => row?.location_master?.name,
         width: "9rem",
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/contractor-master/edit/${row?.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const filterdData = dataList?.filter?.((item) => {
         return (
            item?.name?.toLowerCase()?.includes(searchText) ||
            item?.account_holder_name?.toLowerCase()?.includes(searchText) ||
            item?.location?.toLowerCase()?.includes(searchText)
         );
      });
      setRecords(filterdData);
   };

   return (
      <div>
         <BodyHeader title="Contractor Master List" />
         <div className="px-3">
            <div className=" d-flex justify-content-between">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />

               <DownloadReportButton
                  onDownloadReport={handleDownloadReport}
                  confirmPopup={reportPopup}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
};

export default ContractorMasterList;
